import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

import { PlayerListenerComponentDirective } from '../../../base-component/player-listener.component'
import { ILicense } from '../../../Interface/license'
import { IMood } from '../../../Interface/mood'
import { IStyle } from '../../../Interface/style'
import { ICartTrack, ImagesType, ISong, TracksTypes } from '../../../Interface/track'
import { PlayerLogic } from '../../../player/AngPlayer'
import { CartService } from '../../../services/cart.service'
import { RoutingPathService } from '../../../services/environment.service'
import { CurrencySignType, I18nService, LgType } from '../../../services/prod/i18n.service'
import { TracksService } from '../../../services/tracks.service'
import { AppType } from '../../../types/app.type'

type ModelType = {
  id: string
  title: string
  url: string | null
  artist: {
    id: string
    name: string
    url: string | null
  }
  adsMode: boolean
  images: ImagesType
  style?: IStyle
  mood?: IMood
  license?: ILicense
  bpm?: number
}

type BeatViewModel = ModelType & {
  artist: { beatmakerVerified: boolean }
}

export const IBeatUISelector = (track: ICartTrack, routingService: RoutingPathService): BeatViewModel => {
  return {
    id: track.id.toString(),
    title: track.name,
    artist: {
      beatmakerVerified: track.beatmakerVerified,
      id: track.beatmakerId.toString(),
      name: track.beatmakerName,
      url: routingService.getBeatmakerPageUrl(track.beatmakerId)
    },
    images: track.images,
    adsMode: false,
    // url for free-beat or beat
    url:
      track.type === 'free-beat'
        ? routingService.getFreeBeatPageUrl(track.id)
        : routingService.getBeatPageUrl(track.id),
    style: track.style,
    mood: track.mood,
    license: track.license,
    bpm: track.bpm
  }
}

export const ISongUISelector = (track: ISong, routingService: RoutingPathService): ModelType => ({
  id: track.id.toString(),
  title: track.title,
  artist: {
    id: track.artistId.toString(),
    name: track.artistName,
    url: routingService.getArtistPageUrl(track.artistId)
  },
  images: track.images,
  adsMode: false,
  url: routingService.getSongPageUrl(track.id)
})

@Component({
  selector: 'bmcore-track-descr',
  templateUrl: './bmcore-track-descr.component.html',
  styleUrls: ['./bmcore-track-descr.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
// todo:  ICartTrack is incorrect type. Usually here be ITrack type
export class BmcoreTrackDescrComponent extends PlayerListenerComponentDirective<ICartTrack> implements OnInit {
  @Input() isTrackInCart: boolean
  @Input() parentComponent:
    | 'share-track-popUp'
    | 'track-in-cart-popUp'
    | 'track-item'
    | 'player'
    | 'player-mobSm'
    | 'player-mobLg'
  @Input() appType: AppType
  @Input() ordinalNumber: number
  @Input() isPromoTrack: boolean
  @Input() currencySign: CurrencySignType

  @Input() showVerificationIcon = false
  @Input() verificationIconSize = 24

  @Output() closeCartPopupEvent = new EventEmitter()
  @Output() closePlayerMobLgEvent = new EventEmitter<void>()

  lg: LgType
  modelsSelectors: { [key in TracksTypes]: (track: any, routingService: RoutingPathService) => ModelType } = {
    beat: IBeatUISelector,
    'free-beat': IBeatUISelector,
    song: ISongUISelector
  }

  beatMoodTitle: string

  constructor(
    public player: PlayerLogic,
    protected cartService: CartService,
    private tracksService: TracksService,
    private i18nService: I18nService,
    public routingPathService: RoutingPathService
  ) {
    super(player, cartService)
    this.lg = this.i18nService.getLanguageForPage()
  }

  ngOnInit() {
    this.getBeatMoodTitle()
  }

  // When you click on a track that is in the cart-popup, the popup should be close
  handleTrackNameClick(event: MouseEvent) {
    event.stopPropagation()
    this.closeCartPopupEvent.emit()
    this.closePlayerMobLgEvent.emit()
  }

  getTrackViewModel(): ModelType {
    return this.modelsSelectors[this.fixedBeat.type](this.fixedBeat, this.routingPathService)
  }

  getStyleAndMood(): string {
    const arr = []

    if (this.getTrackViewModel().style?.title) {
      arr.push(this.getTrackViewModel().style?.title)
    }
    if (this.getTrackViewModel().mood?.title) {
      arr.push(this.getTrackViewModel().mood?.title)
    }

    return arr.join(', ')
  }

  getBeatMoodTitle() {
    this.tracksService.Moods.subscribe(moods => {
      moods.forEach(mood => {
        if (mood.id === this.fixedBeat?.mood?.id) {
          this.beatMoodTitle = mood.title
        }
      })
    })
  }
}
